import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultPageByRole } from '@/features/authenticate';

export const Route = createFileRoute('/_private/')({
  component: () => <div />,
  beforeLoad() {
    const path = getDefaultPageByRole();

    return redirect({
      to: path,
      replace: true,
    });
  },
});
